









































import { Component, Vue, Prop } from "vue-property-decorator";
import Danxuan from "./danxuan.vue";
import Duoxuan from "./duoxuan.vue";
import Wenjian from "./wenjian.vue";
import Biaoti from "./biaoti.vue";
import Shuzhiti from "./shuzhiti.vue";
import Wentizu from "./wentizu.vue";
import Biaochi from "./biaochi.vue";
import Wenbenti from "./wenbenti.vue";
import Shijian from "./shijian.vue";
@Component({
  components: {
    Danxuan,
    Duoxuan,
    Wenjian,
    Biaoti,
    Shuzhiti,
    Wentizu,
    Biaochi,
    Wenbenti,
    Shijian
  }
})
export default class ControlTransferCmp extends Vue {
  @Prop()
  private ziduan: any;
  @Prop()
  private index: any;
  @Prop()
  private noDelete: any;
  private cZiduan: any = {};
  private ziduanChange(val) {
    this.$emit("ziduanChange", val);
  }
  /**
   * @description 删除这个字段
   */
  private deleteThis() {
    this.$emit("del", this.index);
  }
}
